import React from 'react'
import PropertyBasicInfo from './PropertyBasicInfo/PropertyBasicInfo'
import { AddressEntityType, ObjectType } from 'types/ApiResponse'
// import EnergyCertificateInfo from './EnergyCertificateInfo/EnergyCertificateInfo'
import { StyledPropertyInfoContainer } from './PropertyInfo.styled'
import OwnershipInfo from './OwnershipInfo/OwnershipInfo'
import EquipmentInfo from './EquipmentInfo/EquipmentInfo'
import ModernizationInfo from './ModernizationInfo/ModernizationInfo'
import RentalAndUsageInfo from './RentalAndUsageInfo/RentalAndUsageInfo'

const PropertyInfo = (props: any) => {
  const { propertyData }: { propertyData: AddressEntityType } = props
  return (
    <StyledPropertyInfoContainer>
      <PropertyBasicInfo propertyData={propertyData} />
      {propertyData.propertyDetails.objectType !== ObjectType.PLOT_OF_LAND && (
        <>
          <OwnershipInfo propertyData={propertyData} />
          <RentalAndUsageInfo propertyData={propertyData} />
          {/* <EnergyCertificateInfo propertyData={propertyData} /> */}
          <EquipmentInfo propertyData={propertyData} />
          {propertyData.propertyDetails.constructionYear <= new Date().getFullYear() - 10 && (
            <ModernizationInfo propertyData={propertyData} />
          )}
        </>
      )}
    </StyledPropertyInfoContainer>
  )
}

export default PropertyInfo
